import React from "react";
import { useSearchParams } from "react-router-dom";
import { LogIn, ShieldCheck } from "lucide-react";
import { useAuth } from "@/lib/auth";

const ERRORS = {
    forbidden: "Cet email n'est pas autorisé à accéder au backoffice.",
    invalid_state: "Session de connexion expirée. Réessayez.",
    missing_code: "Connexion interrompue. Réessayez.",
    oidc_failed: "Impossible de communiquer avec Infomaniak.",
    no_email: "Votre compte Infomaniak ne fournit pas d'adresse email.",
};

export default function AdminLogin() {
    const { login, user, loading } = useAuth();
    const [params] = useSearchParams();
    const errorKey = params.get("error");
    const errorMsg = errorKey ? (ERRORS[errorKey] || errorKey) : null;

    if (!loading && user) {
        window.location.replace("/admin");
        return null;
    }

    return (
        <div className="min-h-screen bg-brand-cream flex items-center justify-center px-6" data-testid="admin-login-page">
            <div className="w-full max-w-md">
                <div className="text-center mb-10">
                    <img src="/brand/logo-300.webp" alt="La Lutrive" className="h-16 w-auto mx-auto mb-6" />
                    <p className="ll-eyebrow text-brand-primary mb-2">Backoffice</p>
                    <h1 className="font-display text-3xl text-brand-ink">Connexion gérants</h1>
                </div>

                <div className="bg-white border border-brand-line p-8">
                    <p className="font-sans text-sm text-brand-ink/70 leading-relaxed mb-6">
                        Cet espace est réservé à l'équipe de la pharmacie. Connectez-vous avec votre compte Infomaniak.
                    </p>

                    {errorMsg && (
                        <div className="mb-5 p-3 bg-red-50 border border-red-200 text-red-700 text-sm font-sans rounded">
                            {errorMsg}
                        </div>
                    )}

                    <button
                        onClick={login}
                        className="ll-btn ll-btn-primary w-full justify-center"
                        data-testid="login-infomaniak-btn"
                    >
                        <LogIn className="h-4 w-4" />
                        Se connecter avec Infomaniak
                    </button>

                    <div className="mt-6 flex items-start gap-3 text-xs font-sans text-brand-ink/55">
                        <ShieldCheck className="h-4 w-4 text-brand-primary mt-0.5 shrink-0" />
                        <p>
                            Connexion sécurisée via OAuth2 / OpenID Connect — aucun mot de passe ne transite par notre serveur.
                        </p>
                    </div>
                </div>

                <div className="text-center mt-6">
                    <a href="/" className="text-sm text-brand-ink/60 hover:text-brand-primary ll-link-underline">
                        ← Retour au site
                    </a>
                </div>
            </div>
        </div>
    );
}
